module.exports = __webpack_public_path__ + "img/germin-flag.cfffbff3.png";